import { Layout } from "../components/layout/Layout";
import { useTranslation } from "../translations/LanguageContext";

// Team member names are proper nouns and are intentionally NOT run
// through the translation dictionary — only their role labels are.
const TEAM = [
    { roleKey: "lead", name: "Dawn Knight" },
    { roleKey: "colead", name: "Fernando Alva Manchego" },
    { roleKey: "colead", name: "Jonathan Morris" },
    { roleKey: "ra", name: "Nicolas Gutierrez Rolon" },
    { roleKey: "ra", name: "Jonathan Davies" },
];

export function About() {
    const { t } = useTranslation();
    const e = t("aboutPage.entries");

    return (
        <Layout>
            <section className="page-header">
                <div className="page-header-left">
                    <span className="page-eyebrow">{t("common.brand")}</span>
                    <h1 className="page-title">{t("aboutPage.title")}</h1>
                </div>
            </section>

            <section className="dossier">
                <div className="dossier-spine" aria-hidden="true" />

                <article className="entry entry-left">
                    <span className="entry-index">01</span>
                    <div className="entry-body">
                        <span className="entry-tag">{e.background.tag}</span>
                        <h2 className="entry-title">{e.background.title}</h2>
                        <p className="entry-text">{e.background.text}</p>
                    </div>
                </article>

                <article className="entry entry-right">
                    <span className="entry-index">02</span>
                    <div className="entry-body">
                        <span className="entry-tag">{e.people.tag}</span>
                        <h2 className="entry-title">{e.people.title}</h2>
                        <ul className="entry-list">
                            {TEAM.map((member) => (
                                <li key={member.name}>
                                    <span className="entry-list-role">{e.people.roles[member.roleKey]}</span>
                                    <span className="entry-list-name">{member.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </article>

                <article className="entry entry-left">
                    <span className="entry-index">03</span>
                    <div className="entry-body">
                        <span className="entry-tag">{e.advisory.tag}</span>
                        <h2 className="entry-title">{e.advisory.title}</h2>
                        <p className="entry-text">{e.advisory.text}</p>
                        <ul className="entry-list entry-list-plain">
                            {e.advisory.list.map((item) => <li key={item}>{item}</li>)}
                        </ul>
                    </div>
                </article>

                <article className="entry entry-right">
                    <span className="entry-index">04</span>
                    <div className="entry-body">
                        <span className="entry-tag">{e.affiliation.tag}</span>
                        <h2 className="entry-title">{e.affiliation.title}</h2>
                        <p className="entry-text">{e.affiliation.text}</p>
                    </div>
                </article>
            </section>
        </Layout>
    );
}
